import { Action } from '@ngrx/store';

export function querySuccessType<TModel>(module: string, type: { new(): TModel; }): string {
  return `[${module}] Query Successful for ${(type as any).$typeName}`;
}

export class QuerySuccessAction<TModel> implements Action {
  readonly type: string;

  constructor(module: string, modelType: { new(): TModel; }, public payload: { items: TModel[], totalCount: number } | any) {
    this.type = querySuccessType(module, modelType);
  }
}



// WEBPACK FOOTER //
// ./src/app/pillar/dashboard/store/actions/QuerySuccessAction.ts